declare const __BUILD_ID__: string
declare const __DEPLOY_DATE__: string | null

type BuildMeta = {
  buildId: string
  deployDate: string | null
}

const currentBuildId: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'unknown'
const currentDeployDate: string | null =
  typeof __DEPLOY_DATE__ === 'string' ? __DEPLOY_DATE__ : null

export const currentBuildMeta: BuildMeta = {
  buildId: currentBuildId,
  deployDate: currentDeployDate
}

export const CONFIRM_DELAY_MS = 3_000

export async function fetchLatestBuildMeta(): Promise<BuildMeta | null> {
  try {
    const response = await fetch(`/meta.json?cb=${currentBuildId}`, { cache: 'no-cache' })
    if (!response.ok) return null
    const meta = (await response.json()) as Partial<BuildMeta>
    if (typeof meta.buildId !== 'string') return null
    return { buildId: meta.buildId, deployDate: meta.deployDate ?? null }
  } catch {
    return null
  }
}

function toTime(date: string | null): number | null {
  if (!date) return null
  const time = Date.parse(date)
  return Number.isNaN(time) ? null : time
}

export function isOutdatedBuild(latest: BuildMeta | null | undefined): boolean {
  if (!latest?.buildId) return false
  if (currentBuildId === 'unknown') return false
  if (latest.buildId === currentBuildId) return false

  const latestTime = toTime(latest.deployDate)
  const currentTime = toTime(currentDeployDate)
  if (latestTime !== null && currentTime !== null) return latestTime > currentTime

  return true
}

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export async function fetchConfirmedBuildMeta(): Promise<BuildMeta | null> {
  const first = await fetchLatestBuildMeta()
  if (!isOutdatedBuild(first)) return first

  await wait(CONFIRM_DELAY_MS)
  const second = await fetchLatestBuildMeta()
  if (second?.buildId !== first?.buildId) return null

  return second
}
